export default "__VITE_ASSET__af417377__"